import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";

import {
    GET_RP_DETAIL_AVG_GAS_DELIVERY,
    baseUrl,
} from "../../../helpers/url_api_constant";

import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";

function TabOne(props) {
    // console.log(props);
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number))
            return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
                minimumFractionDigits: digit,
            });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }

    let history = useHistory();
    let { pid, date } = useParams();
    const dispatch = useDispatch();
    const permission = getPermission();
    const [pageAdd, setPageAdd] = useState(false);
    const [modelDeviceList, setModelDeviceList] = useState([]);
    const [listUser, setListUser] = useState([]);
    const [dropDownUser, setDropDownUser] = useState(null);

    //Sort Page//
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total ms-2">
            Showing {from} to {to} of {size} Results
        </span>
    );
    // 
    const options = {
        paginationSize: 4,
        pageStartIndex: 1,
        // alwaysShowAllBtns: true, // Always show next and previous button
        // withFirstAndLast: false, // Hide the going to First and Last page button
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
        // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [
            {
                text: "100",
                value: 100,
            },
            {
                text: "250",
                value: 250,
            },
            {
                text: "500",
                value: 500,
            },
            {
                text: "1000",
                value: 1000,
            },
        ],
    };

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

    const columns = [
        // {
        //     dataField: "Dummy",
        //     text: "No.",
        //     formatter: CountIndexRow,
        //     headerAlign: "center",
        //     align: "center",
        //     headerStyle: {
        //         width: "5%",
        //         fontSize: "12px",
        //     },
        //     style: {
        //         width: "5%",
        //         fontSize: "12px",
        //     },
        // },
        {
            dataField: "YEAR_NAME",
            text: "Year",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "PLAN",
            text: "Yearly Plan",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "ACTUAL",
            text: "Actual",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "DIFF",
            text: "Diff",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "DAY",
            text: "Day",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "ACC_PLAN",
            text: "Acc Plan",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "ACC_ACTUAL",
            text: "Acc Actual",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
        {
            dataField: "REMARK",
            text: "Remark",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "2vw",
                fontSize: "12px",
            },
            style: {
                width: "2vw",
                fontSize: "12px",
            },
            sort: false,
        },
    ];

    //onInit//
    useEffect(function () {
        fetchData();
    }, [props.avgGasYear]);
    //onInit//

    const SelectStyle = {
        option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
            ...provided,
            ...isFocused && ({ backgroundColor: '#2E3460' })
        }),
    }

    const gotoMainMenu = () => {
        history.push({
            pathname: "/average-gas-delivery-report", state: {  // location state
                goBack: true,
            },
        });
    };

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.ALIAS_NAME < b.ALIAS_NAME) {
            return -1;
        }
        if (a.ALIAS_NAME > b.ALIAS_NAME) {
            return 1;
        }
        return 0;
    }

    const fetchData = async () => {
        dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_RP_DETAIL_AVG_GAS_DELIVERY, { MONTHFLOW_YEAR: moment(props.avgGasYear).format("YYYY-01-01"), IS_BILLING: false });
            // console.log(res);
            setModelDeviceList(res.data.rpGasDeliveryAvgList);
            // .map((obj) => {
            //     return {
            //         ...obj, PLAN: numberFormat(obj.PLAN, 2), ACTUAL: numberFormat(obj.ACTUAL, 2), DIFF: numberFormat(obj.DIFF, 2), DAY: numberFormat(obj.DAY, 2),
            //         ACC_PLAN: numberFormat(obj.ACC_PLAN, 2), ACC_ACTUAL: numberFormat(obj.ACC_ACTUAL, 2)
            //     }
            // }));
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        dispatch(loadingAction.hideLoading());
    };

    function RenderList(prop) {
        // console.log(prop);
        return (
            <tr>
                {/* <td className="text-center">{prop.indexlist}</td> */}
                <td className="text-center">{prop.data.YEAR_NAME}</td>
                <td className="text-center">{numberFormat(prop.data.PLAN, 2)}</td>
                <td className="text-center">{numberFormat(prop.data.ACTUAL, 2)}</td>
                <td className="text-center">{numberFormat(prop.data.DIFF, 2)}</td>
                <td className="text-center">{numberFormat(prop.data.DAY, 2)}</td>
                <td className="text-center">{numberFormat(prop.data.ACC_PLAN, 2)}</td>
                <td className="text-center">{numberFormat(prop.data.ACC_ACTUAL, 2)}</td>
                <td className="text-center">{prop.data.REMARK}</td>
            </tr>
        );
    }

    return (
        <React.Fragment>
            <Row>
                <Col
                    sm="12"
                    className="d-flex align-items-center justify-content-end"
                >
                    <div className="d-grid gap-2 d-md-block">
                        <Button
                            onClick={() => gotoMainMenu()}
                            // className="btn-rounded"
                            color="secondary"
                            className="mt-0 mb-0"
                        >
                            <i className="fas fa-angle-double-left"></i>
                            &nbsp; Back
                        </Button>
                    </div>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col sm="12">
                    <div style={{ width: "100%" }}>
                        <Table className="table table-bordered mb-0">
                            <thead style={{ fontSize: "1.5vh" }}>
                                <tr>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "5%" }}>Year</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Yearly Plan</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Actual</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Diff</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Day</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Acc. Plan</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "10%" }}>Acc. Actual</th>
                                    <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "35%" }}>Remark</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.6vh" }}>
                                {modelDeviceList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
                            </tbody>
                        </Table>

                        {/* <div>
                        <BootstrapTable
                            id="tabone-average-gas-report-table"
                            keyField="PID"
                            data={modelDeviceList}
                            columns={columns}
                            headerClasses="header-style"
                            rowStyle={rowStyleFontWhite}
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory(options)}
                            hover
                        />
                        </div> */}
                    </div>
                </Col>
            </Row>

        </React.Fragment >
    );
}

TabOne.propTypes = {
    t: PropTypes.any,
    avgGasYear: PropTypes.any,
};


export default TabOne;
